// extracted by mini-css-extract-plugin
export default {"information":"InformationAboutСompany_information__PfoCR","title":"InformationAboutСompany_title__RGSH+","text":"InformationAboutСompany_text__+ahDY"};